module.exports = __webpack_public_path__ + "img/new-rule-options.2f9928bc.png";